import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import DriverDTO from '../interfaces/driverDTO';
import { DriverRecordRequestService } from './driverrecordrequest.service';
import httpConfig from '../helpers/http-config';
import { catchError, map, of } from 'rxjs';

@Injectable({
     providedIn: 'root'
})
export class DriverService {

     state = {
          authCode: '',
          recordStatus: '',
          error: {},
          driverProfile: {}
     };

     phoneRegex: RegExp = /^\d{6}$/;

     constructor(private http: HttpClient,
          private driverRecordRequestService: DriverRecordRequestService) {

     }

     // From order-success.component
     getAuthCode(token: string) {
          let authMethod = 'Anonymous';
          const authenticatedUser = localStorage.getItem('username');
          if (authenticatedUser) {
               authMethod = 'Login.gov';
          }
          return this.driverRecordRequestService.getAuthCode('success', token, authMethod)
               .then((response: any) => {
                    if (response && response.isSuccess && response.authCode) {
                         localStorage.setItem('authCode', response.authCode);
                         this.state.authCode = response.authCode;
                         return response.authCode;
                    } else {
                         localStorage.setItem('authCode', '');
                         this.state.authCode = '';
                         return null;
                    }
               },
                    (error: any) => {
                         this.logError(error);
                         return Promise.reject(error);
                    }
               );
     }

     getStoredAuthCode() {
          return localStorage.getItem('authCode') || '';
     }

     clearAuthCode() {
          localStorage.setItem('authCode', '');
          this.state.authCode = '';
     }

     setDriverProfile(driverProfile: DriverDTO) {
          this.state.driverProfile = driverProfile;
     }

     logError(error: any) {
          console.error(error);
          this.state.error = error;
     }

     updateStatus(status: string) {
          this.state.recordStatus = status;
     }

     updateMonitoring(driverProfile: DriverDTO): any {
          if (driverProfile) {
               const url: string = `${environment.APP_API_URL}/api/v1/Applicant/UpdateMonitoring`;
               return this.http.put(url, driverProfile, httpConfig())
                    .pipe(
                         map((response) => (response as any)),
                         catchError((error: any) => {
                              console.error('Exception updating monitoring.');
                              return [];
                         })
                    )
          }
     }
}
